import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  FormControl,
  OutlinedInput,
  Typography,
} from "@mui/material";
import ApiService from "./../../services/api-service";
import "./index.scss";
import { validateEmail } from "../../constants/function";
import AddCollaboratorPopup from "./../../components/AddCollaboratorPopup";
import Loader from "./../Loader";
import { fullName } from "./../../constants/function";
import { Images } from "./../../assets/common";
import AsyncImage from "../AsyncImage";
import notifier from "../Notifier";
import { useTranslation } from "react-i18next";
export default function SikiInput({
  label,
  icon,
  placeholder,
  value,
  onChange,
  info,
  width,
  isSubLabel,
  multi,
  type,
  isUpload,
  onClick,
  name,
  isSearch,
  disabled,
  isDate,
  onInvite,
  isRoyalty,
  top,
  isArtist,
  left,
  songTitle,
  artistName,
  percentage,
}) {
  const { t } = useTranslation("common");
  const [loading, setLoading] = React.useState(false);
  const [val, setVal] = React.useState("");
  const [result, setResult] = useState([]);
  const [keyWords, setKeyWords] = useState();
  const [contributers, setContributers] = useState(false);
  const handleSearch = async (keyword) => {
    setKeyWords(keyword);
    if (isSearch && keyword) {
      try {
        const response = await ApiService.SEARCH_USER(keyword);
        setResult(response["result"]);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleSearchArtist = async (keyword) => {
    setKeyWords(keyword);
    if (isSearch && keyword) {
      try {
        const response = await ApiService.SEARCH_ARTIST(keyword);
        setResult(response["result"]);
      } catch (error) {
        console.log(error);
      }
    }
  };
  /**
   * @param  {Array<object>} list
   */
  const handleInvite = (list) => {
    if (list.length === 0) {
      //if search results is equal to 0 then only open popup
      if (isRoyalty && validateEmail(keyWords)) {
        setContributers(true);
      } else if (validateEmail(keyWords)) {
        setContributers(true);
      }
    }
  };
  const handleClose = (e, close) => {
    if (!e) {
      setContributers(false);
    } else {
      setResult([]);
      setKeyWords("");
      setVal(`${e["firstName"]} ${e["lastName"]}`);
      onInvite(e, e["_id"]);
      setContributers(false);
    }
  };
  const save = async () => {
    const payload = {
      email: val,
    };
    try {
      setLoading(true);
      const response = await ApiService.INVITE_ROYALTIES(payload);
      setLoading(false);
      onChange(`${val}`, response["result"]._id);

      setKeyWords("");
      setResult([]);
    } catch (error) {
      setLoading(false);
    }
  };

  React.useEffect(() => setVal(value), [value]);

  let year = new Date().getFullYear();

  var typingTimer; //timer identifier
  var doneTypingInterval = 1000; //time in ms, 5 seconds for example

  const onKeyup = () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  };

  function doneTyping() {
    if (keyWords?.length >= 3) {
      handleSearchArtist(keyWords);
    }
  }

  return (
    <FormControl
      className="__form_control"
      style={{ width: width ? width : "100%", marginTop: top ? top : "auto" }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {label ? (
          <Typography
            className={isSubLabel ? "__info" : "__label"}
            variant="body1"
            style={{ marginLeft: left ? left : "" }}
          >
            {label}
          </Typography>
        ) : null}
        {info ? (
          <Typography className="__info" variant="body2">
            {info}
          </Typography>
        ) : null}
      </Stack>

      <Box className="__upload_inputbox">
        {multi ? (
          <OutlinedInput
            type={type ? type : "text"}
            value={val}
            multiline
            maxRows={4}
            onChange={(e) => {
              setVal(e.target.value);
              onChange(e.target.value);
            }}
            className="__input_area"
            placeholder={placeholder}
          />
        ) : isArtist ? (
          <OutlinedInput
            type={isDate ? "date" : type ? type : "text"}
            value={val}
            onChange={(e) => {
              onChange(e.target.value);
              setVal(e.target.value);
              // handleSearchArtist(e.target.value);
              setKeyWords(e.target.value);
            }}
            onKeyDown={(e) =>
              type && type === "number"
                ? ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                : null
            }
            onKeyUp={() => onKeyup()}
            className="__input"
            name={name}
            placeholder={placeholder}
            disabled={disabled ? disabled : false}
          />
        ) : (
          <OutlinedInput
            type={isDate ? "date" : type ? type : "text"}
            value={val}
            onChange={(e) => {
              onChange(e.target.value);
              setVal(e.target.value);
              handleSearch(e.target.value);
            }}
            onKeyDown={(e) =>
              type && type === "number"
                ? ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                : null
            }
            className="__input"
            name={name}
            placeholder={placeholder}
            disabled={disabled ? disabled : false}
          />
        )}
        {icon ? icon : null}
      </Box>
      <Box
        sx={{
          position: "absolute",
          zIndex: "1",
          top: "60px",
          background: "#262626",
          borderRadius: "6px",
        }}
      >
        {keyWords && isSearch ? (
          <Box>
            <Typography
              className="_cp"
              onClick={() => handleInvite(result)}
              sx={{ padding: "5px" }}
            >
              {t("invite")} {val}
            </Typography>
            <Box style={{ maxHeight: "50vh", overflow: "scroll" }}>
              {result &&
                result.map((r, index) => (
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{
                      padding: "5px",
                      color: "#ffffff50",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setVal(`${fullName(r)}`);
                      {
                        isArtist
                          ? onChange(
                              r.displayArtistName,
                              r.uId,
                              r.profileImg,
                              r.firstName,
                              r.fullName,
                              r.lastName
                            )
                          : onChange(`${fullName(r)}`, r._id);
                      }
                      // onChange(`${fullName(r)}`, r._id);
                      setResult([]);
                      setKeyWords("");
                    }}
                  >
                    <AsyncImage
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                      }}
                      src={
                        r["profileImg"] && r["profileImg"]["filePath"]
                          ? r["profileImg"]["filePath"]
                          : r["profileImg"]
                          ? r["profileImg"]
                          : Images.user_dummy
                      }
                    />
                    {/* <img
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                      }}
                      src={
                        r["profileImg"] && r["profileImg"]["filePath"]
                          ? r["profileImg"]["filePath"]
                          : Images.user_dummy
                      }
                    /> */}
                    <Typography className="_cp" key={index}>
                      {fullName(r)}
                    </Typography>
                  </Stack>
                ))}
            </Box>
          </Box>
        ) : null}
        <AddCollaboratorPopup
          open={contributers}
          handleClose={(e, close) => handleClose(e, close)}
          email={val}
          isRoyalty={isRoyalty}
          songTitle={songTitle}
          artistName={artistName}
          percentage={percentage}
        />
      </Box>
      {loading ? <Loader /> : null}
    </FormControl>
  );
}
